import { IAdobeInteraction } from "@abbvie-epi/common/adobe-analytics";
import { ScreeningTabEnum } from "@abbvie-epi/common/enums";
import { AfterContentInit, Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { AnalyticsHelperService } from "../../services/analytics-helper.service";
import { HeroService } from "../../services/hero.service";
import { ResultsService } from "../../services/results.service";

@Component({
    selector: "app-screening-tool-landing-page",
    templateUrl: "./screening-tool-landing-page.component.html",
    styleUrls: ["./screening-tool-landing-page.component.scss"]
})
export class ScreeningToolLandingPageComponent implements OnInit, AfterContentInit {
    public activeTab: string;
    public hasResults: boolean;

    public ScreeningTabEnum = ScreeningTabEnum;

    @ViewChild("hero", { static: true }) hero: ElementRef;

    constructor(
        private activatedRoute: ActivatedRoute,
        private router: Router,
        public heroService: HeroService,
        private resultsService: ResultsService,
        private analyticsHelper: AnalyticsHelperService
    ) {}

    ngOnInit() {
        this.getRouteFragment();
        this.getResultStatus();
    }

    ngAfterContentInit() {
        this.heroService.setHero(this.hero);
    }

    public changeTab(tab: ScreeningTabEnum) {
        const analyticsOverrides = this.getTabAnalyticsOverrides("screening-tool-landing" + "#" + tab);
        const analyticsTag = `screening-tool-landing-tab-${tab}`;

        this.analyticsHelper.trackInteraction(analyticsTag, analyticsOverrides);

        this.router.navigate(["screening-tool-landing"], { fragment: tab });
    }

    private getRouteFragment() {
        this.activatedRoute.fragment.subscribe((value) => {
            if (value) {
                this.activeTab = value;
                this.analyticsHelper.trackPageLoad(this.activeTab);
            } else {
                this.activeTab = "introduction";
                this.router.navigate(["screening-tool-landing"], { fragment: this.activeTab });
            }
        });
    }

    private getResultStatus() {
        if (this.resultsService.getResultStatus()) {
            this.hasResults = true;
        } else {
            this.hasResults = false;
        }
    }

    private getTabAnalyticsOverrides(urlPath: string): IAdobeInteraction {
        return {
            link: {
                type: "internal",
                url: urlPath
            },
            component: {
                name: "tabs",
                position: "content",
                type: "content"
            },
            content: {
                type: "link"
            },
            interaction: {
                type: "link"
            }
        };
    }
}
